import formHelper from 'formhelper';
import $ from 'jquery';

const selectorSubmitMessage = '.js-form-submit-message';

formHelper.always.xhrReady = function() {
  const formId = this.$form.attr('id');
  if (!formId) return;

  $(selectorSubmitMessage)
      .filter(`[data-form-id=${formId}]`)
      .show();
};
formHelper.always.xhrComplete = function() {
  $(selectorSubmitMessage).hide();
};



formHelper.addRule({
  form: '.js-fh-standard',
  status: {
    SUCCESS() {
      this.$form.find('.js-fh-contents').hide();

      const redirect = this.$form.attr('data-redirect-to');
      if (redirect) {
        this.redirect(redirect);
      }
    },
    ACCOUNT_LOGIN: '/my-account/login'
  }
});

formHelper.addRule({
  form: '.js-fh-reload',
  status: {
    SUCCESS() {
      this.redirect(window.location.href);
    }
  }
});

formHelper.addRule({
  form: '.js-fh-redirect-to',
  status: {
    SUCCESS() {
      const redirectTo = this.data && this.data.redirectTo ?
          this.data.redirectTo :
          this.$form.attr('data-fh-redirect-to');
      this.redirect(redirectTo);
    }
  }
});

$(_ => {

  // Temporarily change a form's action and/or id
  // to trigger a different formRule

  $('.js-on-change-alt-form-submit').on('change', (event) => {

    const $el = $(event.target);
    const $form = $el.parents('form');

    const originalId = $form.attr('id');
    const originalAction = $form.attr('action');

    const tempId = $el.attr('data-alt-form-id') || originalId;
    const tempAction = $el.attr('data-alt-form-action') || originalAction;

    $form
        .attr('id', tempId)
        .attr('action', tempAction)
        .submit()
        .attr('id', originalId)
        .attr('action', originalAction);
  });
});